import { ThumbnailConfig, TransitionEffect } from '@monorepo/types';
import { Asset, AudioTrack } from './remotion-types';
import { groupBy } from 'lodash';

export enum TrackType {
  Thumbnail = 'thumbnail',
  Image = 'image',
  Text = 'text',
  Video = 'video',
  Gif = 'gif',
  Audio = 'audio',
  Voiceover = 'voiceover',
  Track = 'track',
}

export type TrackThumbnail = Pick<ThumbnailConfig, 'text' | 'type'>;

export type TrackItemData = TrackThumbnail | Asset | AudioTrack | any;

export interface TrackItem {
  type: TrackType;
  transition?: TrackTransition;
  from: number;
  durationInFrames: number;
  left?: number | string;
  top?: number | string;
  height?: number | string;
  width?: number | string;
  data: TrackItemData;
}

export interface TrackTransition {
  outEffect: TransitionData;
}

export interface TransitionData {
  effect: TransitionEffect;
}

export interface TrackGroup {
  tracks: TrackItem[];
  type: TrackType | 'asset';
  index: number;
}

export const isAssetTrack = (type: TrackType): boolean => {
  return [TrackType.Video, TrackType.Image].includes(type);
};

export const groupTracks = (tracks: TrackItem[]): TrackGroup[] => {
  // Group tracks by type using lodash
  const groupedByType = groupBy(tracks, (track) => {
    // If it's an image or video, group as 'asset'
    if (isAssetTrack(track.type)) {
      return 'asset';
    }
    return track.type;
  });

  // Convert the grouped object into array of TrackGroup
  return Object.entries(groupedByType).map(([type, items], index) => ({
    tracks: items,
    type: type as TrackType,
    index,
  }));
};
